import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "cn";
import type * as React from "react";

const badgeDotVariants = cva(
  cn(
    /* sorted */
    "inline-flex",
    "rounded-full outline-2 outline-outline-light",
  ),
  {
    variants: {
      color: {
        purple: "bg-bg-primary-max",
        black: "bg-bg-dark-max",
        red: "bg-bg-negative-max",
        green: "bg-bg-success-max",
        orange: "bg-bg-warning-max",
        yellow: "bg-bg-yellow-max",
        lime: "bg-bg-lime-max",
        blue: "bg-bg-blue-max",
        indigo: "bg-bg-indigo-max",
        fuchsia: "bg-bg-fuchsia-max",
        pink: "bg-bg-pink-max",
        rose: "bg-bg-rose-max",
        amber: "bg-bg-amber-max",
        cyan: "bg-bg-cyan-max",
      },
      size: {
        sm: "size-1",
        base: "size-2",
        md: "size-3",
        lg: "size-4",
      },
    },
    defaultVariants: {
      color: "purple",
      size: "base",
    },
  },
);

type BadgeDotProps = React.ComponentProps<"span"> &
  VariantProps<typeof badgeDotVariants> & {
    asChild?: boolean;
  };

function BadgeDot({
  className,
  color,
  size,
  asChild = false,
  ...props
}: BadgeDotProps) {
  const Comp = asChild ? Slot : "span";

  return (
    <Comp
      data-slot="badge-dot"
      className={cn(badgeDotVariants({ color, size }), className)}
      {...props}
    />
  );
}

export type { BadgeDotProps };
export { BadgeDot, badgeDotVariants };
